import { render, staticRenderFns } from "./micoapp_point.vue?vue&type=template&id=cf4d2f94&scoped=true"
import script from "./micoapp_point.vue?vue&type=script&lang=js"
export * from "./micoapp_point.vue?vue&type=script&lang=js"
import style0 from "./micoapp_point.vue?vue&type=style&index=0&id=cf4d2f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4d2f94",
  null
  
)

export default component.exports